import cls from './PageError.module.scss'
import whaleFire from 'shared/assets/images/whaleFire.png'
import {
    redirectToCanonicalApplication,
    supportUrl,
} from 'shared/config/externalLinks'
import { ErrorScreen } from 'shared/ui/ErrorScreen'

export const PageError = () => {
    return (
        <ErrorScreen
            actionText="Буп"
            footer={
                supportUrl ? (
                    <>
                        Что-то по-прежнему не работает?{' '}
                        <a className={cls.href} href={supportUrl}>
                            Напиши нам об этом
                        </a>
                    </>
                ) : null
            }
            image={whaleFire}
            imageAlt="Кит в огне"
            onAction={redirectToCanonicalApplication}
            title="Иногда нужно ещё раз нажать, и все заработает"
        />
    )
}
